import {
    HeaderClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
    captionClassName,
    logoClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const PageTopSectionWrapper: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        padding: pxArrayToRem([190, 0, 44]),
    },
});

export const TitleWrapper: StyleRule = ({ theme }) => ({
    position: 'relative',
    flex: 1,

    [`& .${HeaderClassName}`]: {
        position: 'relative',
        display: 'inline',
        textTransform: 'capitalize',
        color: theme.siteVariables.colorScheme.default?.foreground,
    },
});

export const CategoryCountWrapper: StyleRule = ({ theme }) => ({
    position: 'absolute',
    display: 'inline-block',
    margin: pxToRem(8),
    verticalAlign: 'top',
    color: theme.siteVariables.colorScheme.default?.foreground,
});

export const CategoryDescriptionWrapper: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(32),

    [`& > .${labelClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
        paddingRight: pxToRem(72),
    },

    [theme.screen.laptop]: {
        width: pxToRem(590),
    },
});

export const FilterWrapper: StyleRule = () => ({
    paddingTop: pxToRem(42),
});

export const BreadcrumbWrapper: StyleRule = ({ theme }) => ({
    paddingBottom: pxToRem(40),

    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
        cursor: 'default',
    },

    [`& .${logoClassName} svg`]: {
        fill: theme.siteVariables.colorScheme.default?.foreground,
    },
});
